import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import IconeVotoRevogado from '@/components/IconeVotoRevogado';
import { SITUACAO_VOTO } from '@/dominio/SituacaoVoto';
import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import ReactComponent from '../ReactComponent';

class VotoAlteradoRelator extends ReactComponent {
    dialogOpen = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            dialogOpen: observable,
            existeVotoAlteradoRelator: computed,
            existeVotoRevogadoRelator: computed,
            fecharModal: action,
            dataHoraAlteracaoFormatada: computed
        });

        this.createReaction(
            reaction(
                () => this.registro.alertarVotoAlterado,
                () => {
                    if (this.registro.alertarVotoAlterado) {
                        this.dialogOpen = true;
                        this.registro.alertarVotoAlterado = false;
                    }
                }
            )
        );
    }

    get registro() {
        return this.observableProps.registro;
    }

    get existeVotoAlteradoRelator() {
        return moment(this.registro.dataAlteracaoMinuta, 'DD-MM-YYYY-HH-mm-ss').isSameOrAfter(
            moment().startOf('day'),
            'day'
        );
    }

    get existeVotoRevogadoRelator() {
        return (
            this.registro.votos &&
            this.registro.votos.findIndex((voto) => voto.situacaoVoto === SITUACAO_VOTO.REVOGADO.id) !== -1
        );
    }

    fecharModal = () => {
        this.dialogOpen = false;
    };

    get dataHoraAlteracaoFormatada() {
        return moment(this.registro.dataAlteracaoMinuta, 'DD-MM-YYYY-HH-mm-ss').format('DD/MM/YYYY HH:mm:ss');
    }

    render() {
        if (!this.existeVotoAlteradoRelator || !this.existeVotoRevogadoRelator) {
            return null;
        }

        return (
            <>
                <IconeVotoRevogado
                    title={
                        <Typography>{`Minuta de voto alterada pelo relator em ${this.dataHoraAlteracaoFormatada}`}</Typography>
                    }
                    sx={{ cursor: 'pointer' }}
                />
                <Dialog
                    open={this.dialogOpen}
                    onClose={this.fecharModal}
                >
                    <DialogTitle>{this.registro.processo.numeroCompleto}</DialogTitle>
                    <DialogContent>
                        <Typography>
                            {`ATENÇÃO! O VOTO DO RELATOR FOI ALTERADO EM ${this.dataHoraAlteracaoFormatada}`}
                        </Typography>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.fecharModal}
                            color="secondary"
                        >
                            Fechar
                        </Button>
                    </DialogActions>
                </Dialog>
            </>
        );
    }
}

export default inject('stores')(observer(VotoAlteradoRelator));
